/**
 * Video Pause on Image Switch
 * Pauses playing videos when user switches to a different image
 *
 * Debug mode: set window.VideoPauseDebug = true in console to enable debug logging
 */

(function() {
  'use strict';

  const DEBUG = window.VideoPauseDebug || false;
  const log = function() {
    if (DEBUG) console.log.apply(console, ['[VideoPause]'].concat(Array.prototype.slice.call(arguments)));
  };

  log('Initializing...');

  // Store the last selected media ID to detect actual image switches
  let lastSelectedMediaId = null;

  // Listen for thumbnail click events - pause when switching to different media
  document.addEventListener('click', function(e) {
    // Thumbnails have data-thumbnail-id attribute
    const thumbnail = e.target.closest('[data-thumbnail-id]');
    if (thumbnail && thumbnail.dataset.thumbnailId) {
      const clickedMediaId = thumbnail.dataset.thumbnailId;
      const previousMediaId = lastSelectedMediaId;
      log('Thumbnail clicked for media:', clickedMediaId, 'Previous:', previousMediaId);

      // Update tracking ID first
      lastSelectedMediaId = clickedMediaId;

      // Only pause if we're actually switching to a DIFFERENT media
      if (previousMediaId && previousMediaId !== clickedMediaId) {
        log('Switching from', previousMediaId, 'to', clickedMediaId, '- pausing videos');
        const sectionContainer = thumbnail.closest('section') || document;
        pauseAllVideos(sectionContainer, clickedMediaId);
      }
    }
  }, true); // Use capture phase to catch events before they stop propagating

  function pauseAllVideos(container, excludeMediaId) {
    if (!container) {
      log('No container provided');
      return;
    }

    log('Pausing videos, excluding media:', excludeMediaId);

    // Pause native video elements
    const videos = container.querySelectorAll('video');
    log('Videos found:', videos.length);
    videos.forEach(function(video) {
      const mediaItem = video.closest('.product__media-item');
      if (mediaItem && mediaItem.dataset.mediaItemId === excludeMediaId) {
        log('Skipping video in exclude media:', mediaItem.dataset.mediaItemId);
        return;
      }
      if (video && !video.paused) {
        log('Pausing native video');
        video.pause();
      }
    });

    // Pause Plyr players
    const plyrPlayers = container.querySelectorAll('.plyr');
    log('Plyr elements found:', plyrPlayers.length);
    plyrPlayers.forEach(function(plyrEl) {
      const mediaItem = plyrEl.closest('.product__media-item');
      if (mediaItem && mediaItem.dataset.mediaItemId === excludeMediaId) {
        log('Skipping Plyr in exclude media:', mediaItem.dataset.mediaItemId);
        return;
      }
      log('Plyr element found, attempting pause');
      if (plyrEl.plyr) {
        plyrEl.plyr.pause();
      }
      const videoEl = plyrEl.querySelector('video');
      if (videoEl && videoEl.plyr) {
        videoEl.plyr.pause();
      }
    });

    // Pause YouTube iframes
    const iframes = container.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtube-nocookie"]');
    log('YouTube iframes found:', iframes.length);
    iframes.forEach(function(iframe) {
      const mediaItem = iframe.closest('.product__media-item');
      if (mediaItem && mediaItem.dataset.mediaItemId === excludeMediaId) {
        log('Skipping YouTube iframe in exclude media');
        return;
      }
      try {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } catch (e) {
        log('Cannot access iframe:', e.message);
      }
    });
  }

  // Expose global function for manual triggering
  window.pauseAllProductVideos = function(container) {
    pauseAllVideos(container || document);
  };

  log('Ready');

})();